export interface MessagesCenterDTO {
    ["@odata.context"]: string;
    value: MessageCenterDTO[];
}

export interface MessageCenterDTO {
    ["@odata.etag"]?: string;
    createdon?: string;
    svk_activefrom?: string;
    svk_activeto?: string;
    svk_messagecenterid?: string;
    svk_message?: string;
    svk_name: string;
    svk_priority?: number;
    svk_showasnewcasemessage?: boolean;
    _svk_businessarea_value?: string;
}

export interface MessageCenter {
    createdon?: string;
    activeFrom?: string;
    activeTo?: string;
    id?: string;
    message?: string;
    title: string;
    priority?: number;
    showOnCase?: boolean;
    businessArea?: string;
}

export enum MessageBannerState {
    success = "success",
    warning = "warning",
    error = "error",
    none = "none"
}
